import Swiper from 'swiper'
import { Autoplay, Navigation, Pagination, Thumbs } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const carousels = document.querySelectorAll('[data-swiper]')

Swiper.use([Autoplay, Navigation, Pagination, Thumbs])

carousels.forEach((value) => {
  let options

  // Parse swiper options from the data attribute
  if (value.dataset.swiper !== undefined && value.dataset.swiper !== '') {
    options = JSON.parse(value.dataset.swiper)
  }

  // Create a new Swiper instance
  const swiper = new Swiper(value, options)

  // Check if a controlled slider is specified
  if (options?.controlSlider) {
    let controlledSliders = []

    if (Array.isArray(options.controlSlider)) {
      // Handle multiple sliders
      controlledSliders = options.controlSlider.map((selector) => document.querySelector(selector))
    } else {
      // Handle single slider
      controlledSliders.push(document.querySelector(options.controlSlider))
    }

    const swiperControlledInstances = controlledSliders.map((controlledSlider) => {
      const controlledSliderOptions = controlledSlider?.dataset.swiper && JSON.parse(controlledSlider.dataset.swiper)

      // Create a new Swiper instance for each controlled slider
      return new Swiper(controlledSlider, controlledSliderOptions)
    })

    swiper.controller.control = swiperControlledInstances
  }
})
